export default function newTiiHeaderServicesHeaderInterceptor() {
    return {
        request(config) {
            config.headers['Tii-New-Services'] = 'True';
            return config;
        },
    };
}
